import type { Language, QuoteTotals } from "@contracts/index";
import { formatMoney } from "../lib/format";

export function TotalsBox({ totals, language }: { totals: QuoteTotals; language: Language }) {
  const money = (cents: number) => formatMoney(cents, totals.currency, language);
  return (
    <table className="totals">
      <tbody>
        <tr>
          <th>Subtotal</th>
          <td>{money(totals.subtotalCents)}</td>
        </tr>
        <tr>
          <th>{totals.taxMode === "iva16" ? "IVA 16 %" : "Impuestos (exento)"}</th>
          <td>{money(totals.taxCents)}</td>
        </tr>
        <tr className="grand">
          <th>Total {totals.currency}</th>
          <td>{money(totals.totalCents)}</td>
        </tr>
      </tbody>
    </table>
  );
}
